import { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { PolicySheet } from "./PolicySheet";
import { useI18n } from "@/i18n/I18nProvider";

export function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  const [policy, setPolicy] = useState<"privacy" | "terms" | null>(null);

  const offices = [
    "Guatemala",
    "United States",
    "Spain",
    "Belarus",
    "Poland",
    "Portugal",
    "Dubai",
  ];

  return (
    <footer className="relative border-t hairline mt-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5 space-y-6">
            <Logo />
            <p className="max-w-sm text-sm text-muted-foreground leading-relaxed">
              {t.footer.tagline}
            </p>
            <p className="text-xs text-muted-foreground/70">
              {t.footer.legalName}
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xs uppercase tracking-wider text-muted-foreground mb-4">
                {t.footer.explore}
              </h4>
              <ul className="space-y-3 text-sm">
                <li><Link className="link-underline" to="/about">{t.nav.about}</Link></li>
                <li><Link className="link-underline" to="/services">{t.nav.services}</Link></li>
                <li><Link className="link-underline" to="/portfolio">{t.nav.portfolio}</Link></li>
                <li><Link className="link-underline" to="/technology">{t.nav.technology}</Link></li>
                <li><Link className="link-underline" to="/contact">{t.nav.contact}</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-wider text-muted-foreground mb-4">
                {t.contact.offices}
              </h4>
              <ul className="space-y-3 text-sm text-muted-foreground">
                {offices.map((c) => (
                  <li key={c}>{(t.countries as Record<string, string>)[c]}</li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-wider text-muted-foreground mb-4">
                {t.footer.legal}
              </h4>
              <ul className="space-y-3 text-sm">
                <li>
                  <button
                    type="button"
                    onClick={() => setPolicy("privacy")}
                    className="link-underline text-muted-foreground hover:text-foreground"
                  >
                    {t.footer.privacy}
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => setPolicy("terms")}
                    className="link-underline text-muted-foreground hover:text-foreground"
                  >
                    {t.footer.terms}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-8 border-t hairline text-xs text-muted-foreground">
          <p>© {year} {t.footer.legalName}. {t.footer.rights}</p>
          <p className="font-mono">Smart Canvas / v2026.1</p>
        </div>
      </div>
      <PolicySheet
        open={policy === "privacy"}
        onOpenChange={(o) => !o && setPolicy(null)}
        kind="privacy"
      />
      <PolicySheet
        open={policy === "terms"}
        onOpenChange={(o) => !o && setPolicy(null)}
        kind="terms"
      />
    </footer>
  );
}